export default {
   landing: {
      welcome: {
         title: 'CBAS – Cyanobacteria Bloom Alert',
         description: 'CBAS to aplikacja służąca do monitorowania zakwitów polskich jezior. Z wykorzystaniem danych satelitarnych prowadzimy ciągłą obserwację zbiorników wodnych. Dzięki aplikacji mobilnej nasi użytkownicy całkowicie za darmo otrzymują ostrzeżenia o zakwicie sinic.',
         explore: 'Przeglądaj'
      },
      newsletter: {
         emailActionDescription: 'Chcesz otrzymywać powiadomienia e-mail o zagrożeniu zakwitem sinic?',
         emailPlaceholder: 'Wpisz swój adres e-mail',
         emailEmptyError: 'Wpisz swój adres e-mail',
         emailInvalidError: 'Niepoprawny adres e-mail',
         subscribeButton: 'Zapisz się',
         subscriptionSuccess: 'Sprawdź swoją skrzynkę email i kliknij link potwierdzający',
         subscriptionError: 'Wystąpił błąd. Spróbuj ponownie później',
         privacy: {
            text: 'Informacje przekazane w formularzu zapisu do newslettera będą przetwarzane zgodnie z naszę',
            link: 'polityką prywatności'
         }
      },
      aboutUs: {
         title: 'O projekcie',
         columnA: 'CBAS to projekt prowadzony w konsorcjum polsko-francuskim mający na celu zapewnienie infrastruktury pozwalającej na stały monitoring wód śródlądowych w Polsce i Europie. Pilotaż projektu skupia się na obszarze Kaszub i Zalewu Wiślanego.  Zakwity cyjanobakterii występują w zbiornikach wodnych na całym świecie i obejmują zarówno wody śródlądowe jak i morza i oceany. Zakwit uwarunkowany jest warunkami panującymi w danym zbiorniki i zależy od czynników fizykochemicznych jak nasłonecznienie, temperatura, pH, a także od składu wody. Duże znaczenie w powstawaniu zakwitów mają spływające do wód zanieczyszczenia z pól i obszarów miejskich.',
         columnB: 'Do tej pory zidentyfikowano około 40 gatunków cyjanobakterii, które są potencjalnie toksyczne. Szacuje się, że około 50% wszystkich zakwitów wody wiąże się z produkcją toksyn. Zakwity wód mają znaczenie dla gospodarki obszarów nadmorskich i turystycznych, a także dla zdrowia ludzi i zwierząt. Kontakt z toksynami wytwarzanymi przez cyjanobakterie może powodować ostre reakcje skórne i jest potencjalnie niebezpieczny. Zakwity występujące na obszarach o dużym znaczeniu w rybołówstwie prowadzą do znacznych strat ekonomicznych, a także do strat związanych z ograniczeniem turystyki.',
         features: [{
               title: '7000',
               content: 'Tyle jezior znajduje się na terenie Polski. '
            },
            {
               title: '197',
               content: 'Tyle kąpielisk podlegało monitorowaniu przez Państwową Inspekcję Sanitarną w 2015'
            },
            {
               title: '85%',
               content: 'Taka część wszystkich kąpielisk monitorowanych w roku 2015 spełniała warunki sanitarne. '
            },
            {
               title: '50%',
               content: 'Ponad 50% zbiorników wodnych na terenie Polski charakteryzuje się jako sprzyjające zakwitom.'
            },
            {
               title: '1-16',
               content: 'Czas zakwitu wody w zbiorniku waha się od 1 do 16 tygodni i zależy od wielu czynników. '
            },
         ]
      },
      howItWorks: {
         title: 'Jak to działa?',
         step: 'KROK',
         steps: [{
               title: 'Analiza danych satelitarnych',
               content: 'Wykorzystujemy dane satelitarne z europejskich satelit Sentinel 2 i Sentinel 3 a także satelity Landsat 8 należącej do NASA. Badamy koncentrację chlorofilu-a i fikocyjaniny  w zbiornikach wodnych i na tej podstawie identyfikujemy obszary zagrożone zakwitem. '
            },
            {
               title: 'Analiza próbek wody',
               content: 'Wyniki działania naszych algorytmów trafiają do specjalistów, którzy następnie wykonują badania mikrobiologiczne wody we wskazanych zbiornikach. Na tej podstawie jesteśmy w stanie ocenić działanie algorytmów i pilotażowo potwierdzić zagrożenie. '
            },
            {
               title: 'Informacja o zagrożeniu',
               content: 'Gdy algorytmy lub wyniki badań mikrobiologicznych wskazują na zagrożenie informujemy o tym użytkowników. Ostrzeżenia trafiają do dedykowanej aplikacji mobilnej a także na adres e-mail.'
            }
         ]
      }
   },
   cookies: {
      alert: 'Ta strona używa plików cookie oraz Google Analytics w celu m.in. pomiaru statystyk. Zakładamy, że jest to dla Ciebie OK, jednakże możesz przeczytać więcej.',
      accept: 'Zgoda',
      more: 'Przeczytaj więcej'
   },
   privacy: {
      title: 'Polityka prywatności serwisu WWW sinice.pl',
      items: [{
            title: 'INFORMACJE OGÓLNE',
            items: [{
                  title: 'Operatorem Serwisu sinice.pl jest N7 Mobile Sp. z o.o., z siedzibą przy ul. Bukowińskiej 12/1301, 02-703 Warszawa, NIP: 952-21-04-393, KRS: 0000378709'
               },
               {
                  title: 'Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich zachowaniach w następujący sposób:',
                  items: [{
                        title: 'Poprzez dobrowolnie wprowadzone w formularzach informacje'
                     },
                     {
                        title: 'Poprzez zapisywanie w urządzeniach końcowych pliki cookie (tzw. „ciasteczka”).'
                     },
                     {
                        title: 'Poprzez zapisywanie technicznych logów na poziomie serwera www, obsługiwanego przez OVH (operator hostingu prowadzi swoją stronę pod adresem http://ovh.com. Operatorem jest OVH Sp. z o.o.).'
                     }
                  ]
               }, {
                  title: 'Niniejsza Polityka jest dokumentem informacyjnym i nie zastępuje polityki bezpieczeństwa, prowadzonej przez Operatora Serwisu zgodnie zgodnie z przepisami o ochronie danych osobowych.'
               },
               {
                  title: 'W zakresie danych, będących danymi osobowymi w świetnie przepisów o ochronie danych osobowych, administratorem danych jest Operator Serwisu.'
               }
            ]
         }, {
            title: 'INFORMACJE W FORMULARZACH.',
            items: [{
                  title: 'Serwis zbiera informacje podane dobrowolnie przez użytkownika.'
               },
               {
                  title: 'Serwis może zapisać ponadto informacje o parametrach połączenia (oznaczenie czasu, adres IP)'
               },
               {
                  title: 'Dane w formularzu nie są udostępniane podmiotom trzecim inaczej, niż za zgodą użytkownika.'
               },
               {
                  title: 'Dane podane w formularzu mogą stanowić zbiór danych osobowych, wówczas taki zbiór jest rejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych.'
               },
               {
                  title: 'Jeśli dane w formularzu umożliwiają identyfikację osoby fizycznej, to osoba taka ma prawdo do wglądu, modyfikacji i żądania zaprzestania przetwarzania swoich danych w dowolnym momencie. Możliwe jednak, że będzie to powodowało brak dostępu do niektórych funkcji serwisu.'
               },
               {
                  title: 'Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza, np. w celu wysyłania ostrzeżeń o występowaniu zakwitów sinic na monitorowanych jeziorach. '
               }
            ]
         }, {
            title: 'INFORMACJA O PLIKACH COOKIES.',
            items: [{
                  title: 'Serwis korzysta z plików cookies.'
               },
               {
                  title: 'Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Pliki tego rodzaju zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.'
               },
               {
                  title: 'Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu lub podmioty z nim współpracujące.'
               },
               {
                  title: 'Dane podane w formularzu mogą stanowić zbiór danych osobowych, wówczas taki zbiór jest rejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych.'
               },
               {
                  title: 'Pliki cookies wykorzystywane są w następujących celach:',
                  items: [{
                        title: 'tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;'
                     },
                     {
                        title: 'utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;'
                     },
                     {
                        title: 'w celu zapamiętania składu koszyka użytkownika w sklepie internetowym,'
                     },
                     {
                        title: 'określania profilu użytkownika w celu wyświetlania mu dopasowanych materiałów w sieciach reklamowych, w szczególności sieci Google.'
                     }
                  ]
               },
               {
                  title: 'W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.'
               },
               {
                  title: 'Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także automatyczne blokowanie plików cookies Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja przeglądarki internetowej.'
               },
               {
                  title: 'Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.'
               },
               {
                  title: 'Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być również przez współpracujących z operatorem Serwisu reklamodawców oraz partnerów, a także operatorów płatności.'
               },
               {
                  title: 'Zalecamy przeczytanie polityki ochrony prywatności tych firm, aby poznać zasady korzystania z plików cookie wykorzystywane w statystykach: Polityka ochrony prywatności Google Analytics'
               },
               {
                  title: 'Pliki cookie mogą być wykorzystane przez sieci reklamowe, w szczególności sieć Google, do wyświetlenia reklam dopasowanych do sposobu, w jaki użytkownik korzysta z Serwisu. W tym celu mogą zachować informację o ścieżce nawigacji użytkownika lub czasie pozostawania na danej stronie.'
               },
               {
                  title: 'W zakresie informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik może przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia: https://www.google.com/ads/preferences/'
               }
            ]
         }, {
            title: 'LOGI SERWERA',
            items: [{
                  title: 'Informacje o niektórych zachowaniach użytkowników podlegają logowaniu w warstwie serwerowej. Dane te są wykorzystywane wyłącznie w celu administrowania serwisem oraz w celu zapewnienia jak najbardziej sprawnej obsługi świadczonych usług hostingowych.'
               },
               {
                  title: 'Przeglądane zasoby identyfikowane są poprzez adresy URL. Ponadto zapisowi mogą podlegać:',
                  items: [{
                        title: 'czas nadejścia zapytania,'
                     },
                     {
                        title: 'czas wysłania odpowiedzi,'
                     },
                     {
                        title: 'nazwę stacji klienta – identyfikacja realizowana przez protokół HTTP,'
                     },
                     {
                        title: 'informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,'
                     },
                     {
                        title: 'adres URL strony poprzednio odwiedzanej przez użytkownika (referer link) – w przypadku gdy przejście do Serwisu nastąpiło przez odnośnik,'
                     },
                     {
                        title: 'informacje o przeglądarce użytkownika,'
                     },
                     {
                        title: 'informacje o adresie IP.'
                     }
                  ]
               },
               {
                  title: 'Dane powyższe nie są kojarzone z konkretnymi osobami przeglądającymi strony.'
               },
               {
                  title: 'Dane powyższe są wykorzystywane jedynie dla celów administrowania serwerem.'
               }
            ]
         },
         {
            title: 'UDOSTĘPNIENIE I POWIERZENIE PRZETWARZANIA DANYCH.',
            items: [{
                  title: 'Dane podlegają udostępnieniu podmiotom zewnętrznym wyłącznie w granicach prawnie dozwolonych.'
               },
               {
                  title: 'Dane umożliwiające identyfikację osoby fizycznej są udostępniane wyłączenie za zgodą tej osoby.'
               },
               {
                  title: 'Operator może mieć obowiązek udzielania informacji zebranych przez Serwis upoważnionym organom na podstawie zgodnych z prawem żądań w zakresie wynikającym z żądania.'
               },
               {
                  title: 'W zakresie powierzenia przetwarzania danych osobowych Operator Serwisu zawarł pisemną umowę powierzenia przetwarzania danych, uregulowaną w art. 31 ustawy o ochronie danych osobowych, z dostawcą usług hostingowych OVH Sp. z o.o.'
               }
            ]
         },
         {
            title: 'ZARZĄDZANIE PLIKAMI COOKIES – JAK W PRAKTYCE WYRAŻAĆ I COFAĆ ZGODĘ?',
            items: [{
               title: 'Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa, utrzymania preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron www'
            }]
         }
      ]
   },
   explorer: {
      error: {
         apiError: "Błąd pobierania danych z serwera. Spróbuj ponownie poźniej.",
         filterError: "Błędny zakres dat wyszukiwania. Upewniij się, że data początkowa jest wcześniejsza od końcowej."
      },
      alerts: {
         title: "Zagrożenia",
         emptyTitle: "Nie znaleziono zagrożeń dla danego okresu",
         alert: {
            confirmationAlertTitle: "Potwierdzony zakwit",
            detectionAlertTitle: "Podejrzenie zakwitu",
            locationCaption: "Lokalizacja",
            speciesCaption: "Gatunek",
            confidenceCaption: "Stopień pewności"
         }
      },
      images: {
         title: "Zdjęcia satelitarne",
         emptyTitle: "Nie znaleziono zdjęć satelitarnych dla danego okresu"
      },
      valuePicker: {
         disabledPlaceholder: "Aby skorzystać z narzędzia, musisz wybrać zdjęcie satelitarne w panelu wyszukiwania"
      }
   }
}


// WEBPACK FOOTER //
// ./src/i18n/pl.js